import { baseAPI } from './index';

export const getRecentSearchesAPI = async () => {
  return new Promise((resolve, reject) => {
    baseAPI
      .get(`/ipfs/recent`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((data) => resolve(data))
      .catch((e) => {
        reject(e.response.status);
      });
  });
};
